export default {
    errorLoading: function () {
        return 'Os resultados não puderam ser carregados.';
    },
    inputTooLong: function (args) {
        const overChars = args.input.length - args.maximum;

        let message = 'Apague ' + overChars + ' caracter';

        if (overChars != 1) {
            message += 'es';
        }

        return message;
    },
    inputTooShort: function (args) {
        const remainingChars = args.minimum - args.input.length;
        const message = 'Digite ' + remainingChars + ' ou mais caracteres';

        return message;
    },
    loadingMore: function () {
        return 'Carregando mais resultados…';
    },
    maximumSelected: function (args) {
        let message = 'Você só pode selecionar ' + args.maximum + ' ite';

        if (args.maximum == 1) {
            message += 'm';
        } else {
            message += 'ns';
        }

        return message;
    },
    noResults: function () {
        return 'Nenhum resultado encontrado';
    },
    searching: function () {
        return 'Buscando…';
    }
}
